import { Box } from '@material-ui/core';
import React from 'react';

import { PageHighlightTypes } from '../../../../../config/types';
import { useCustomTheme } from '../../../../../hooks/useCustomTheme';

export const DocumentationErrorIcon = ({ iconColor }: { iconColor?: React.CSSProperties['color'] }) => {
  const { palette } = useCustomTheme();
  const color = iconColor || palette.secondary.main;

  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
      <i
        className="material-icons-outlined"
        style={{
          color,
          fontSize: 20,
        }}
      >
        {PageHighlightTypes.incidence.icon}
      </i>
    </Box>
  );
};
